<template>
  <modal :show.sync="$parent.modals.paymentHistory" size="lg">
    <h6 slot="header" class="modal-title" id="modal-title-default">Payment History</h6>
    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light"
      :data="user.invoices"
    >
      <el-table-column label="Date" min-width="150px" prop="created">
        <template v-slot="{row}">
          <div class="media align-items-center">
            <div class="media-body">
              <span class="mb-0">{{row.created}}</span>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="Status" min-width="100px" prop="status">
        <template v-slot="{row}">
          <badge class="badge-dot mr-4" type>
            <i :class="`bg-success`"></i>
            <span class="status">{{row.status}}</span>
          </badge>
        </template>
      </el-table-column>

      <el-table-column label="Amount" min-width="100px" prop="amount_paid"></el-table-column>

      <el-table-column label="Card" min-width="80px" prop="card_brand">
        <template v-slot="{row}">
          <i v-if="row.card_brand === 'Visa'" class="fab cc-table-icon fa-cc-visa"></i>
          <i v-else-if="row.card_brand === 'MasterCard'" class="fab cc-table-icon fa-cc-mastercard"></i>
          <i v-else-if="row.card_brand === 'Discover'" class="fab cc-table-icon fa-cc-discover"></i>
          <i v-else-if="row.card_brand === 'American Express'" class="fab cc-table-icon fa-cc-amex"></i>
          <span v-else>{{row.card_brand}}</span>
        </template>
      </el-table-column>

      <el-table-column label="Receipt" min-width="130px" prop="invoice_url">
        <template v-slot="{row}">
          <a :href="row.invoice_url" target="_blank">View Receipt</a>
        </template>
      </el-table-column>
    </el-table>
  </modal>
</template>

<script>
import { mapState } from "vuex";
import { Table, TableColumn } from "element-ui";

export default {
  name: "payment-history",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapState(["user"])
  }
};
</script>

<style scoped lang="scss">
.cc-table-icon {
  font-size: 1.5rem;
  color: #666;
}
</style>